// removed by extract-text-webpack-plugin
module.exports = {"total-price":"summarytable-module__total-price___tjxOc","due-today":"summarytable-module__due-today___3aPI_","price-large":"summarytable-module__price-large___1A6KY","service":"summarytable-module__service___Fhlku","price":"summarytable-module__price___3GTVA","summarytable":"summarytable-module__summarytable___1b1Dj","summarywrapper":"summarytable-module__summarywrapper___3q3RR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/summarytable.module.scss
// module id = 31
// module chunks = 1